import { type ReactNode } from 'react'
import { ButtonExternal } from 'app/components/buttons'
import { type TinyTeam } from '@terros/common'
import { EditTeamButton } from '../editTeam/EditTeamButton'

export const HeaderActions = ({ team }: { team: TinyTeam | undefined }): ReactNode => {
  if (!team) return null

  return (
    <>
      <ButtonExternal buttonType='icon-full' tooltip='View team' to={`/team/${team.teamId}`} variant='gray' />
      <EditTeamButton buttonType='icon-full' teamId={team.teamId} tooltip='Edit team' />
    </>
  )
}
